var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectortelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7998 14C9.3911 14 10.9172 13.3679 12.0424 12.2426C13.1677 11.1174 13.7998 9.5913 13.7998 8C13.7998 6.4087 13.1677 4.88258 12.0424 3.75736C10.9172 2.63214 9.3911 2 7.7998 2C6.2085 2 4.68238 2.63214 3.55716 3.75736C2.43195 4.88258 1.7998 6.4087 1.7998 8C1.7998 9.5913 2.43195 11.1174 3.55716 12.2426C4.68238 13.3679 6.2085 14 7.7998 14ZM7.7998 15.5C3.65755 15.5 0.299805 12.1422 0.299805 8C0.299805 3.85775 3.65755 0.5 7.7998 0.5C11.9421 0.5 15.2998 3.85775 15.2998 8C15.2998 12.1422 11.9421 15.5 7.7998 15.5ZM5.4673 8.8775L3.5938 8.29325C3.1888 8.1695 3.18655 7.8905 3.68455 7.69025L10.9843 4.87025C11.4081 4.69775 11.6481 4.916 11.5108 5.46275L10.2681 11.3277C10.1811 11.7455 9.9298 11.8452 9.58105 11.6525L7.6678 10.2365L6.77605 11.0975C6.68455 11.186 6.6103 11.2617 6.4693 11.2805C6.32905 11.3 6.21355 11.258 6.1288 11.0255L5.4763 8.87225L5.4673 8.87825V8.8775Z",
    fill: "#B8B8B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectortelegram);
export default __webpack_public_path__ + "static/media/Vectortelegram.2e50838194e04856ac31ad56a1501274.svg";
export { ForwardRef as ReactComponent };